import React, { useState } from 'react';
import { DillModal, DillButton, DillField, DillSelect } from '../../../general/Dill';

const SelectCreditSafeCompanyModal = ({
  open,
  handleClose,
  onSubmit,
  selectList,
}: {
  open: boolean;
  handleClose: () => void;
  onSubmit: (id: string) => void;
  selectList: { label: string; value: string }[];
}) => {
  const [inputFields, setInputFields] = useState<{ id: string }>({ id: '' });
  const [errorFields, setErrorFields] = useState<{ [key: string]: string }>({});

  const handleCloseModal = () => {
    setInputFields({ id: '' });
    setErrorFields({});
    handleClose();
  };

  const handleFieldChange = (field: keyof typeof inputFields, value: string) => {
    setInputFields((prev) => ({ ...prev, [field]: value }));
    setErrorFields((prev) => ({ ...prev, [field]: '' }));
  };

  const validateFields = () => {
    const errors: { [key: string]: string } = {};
    if (!inputFields.id.trim()) {
      errors.id = 'Company is required';
    }
    setErrorFields(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddCompany = async () => {
    if (!validateFields()) return;
    onSubmit(inputFields.id);
    handleCloseModal();
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Select Company"
      maxWidth="540px"
      footer={
        <>
          <DillButton label="Cancel" onClick={handleCloseModal} variant="secondary" />
          <DillButton label="Add Company" onClick={handleAddCompany} />
        </>
      }>
      <DillField label="Company" error={errorFields.id} required>
        <DillSelect
          value={inputFields.id}
          onChange={(value) => handleFieldChange('id', value)}
          options={selectList}
          placeholder="Select a company…"
          error={errorFields.id}
        />
      </DillField>
    </DillModal>
  );
};

export default SelectCreditSafeCompanyModal;
